class RecommendedProducts extends HTMLElement {
    constructor() {
        super();

        let slider = this.querySelector('.featured-collection-content');
        let isDown = false;
        let startX;
        let scrollLeft;

        slider.addEventListener('mousedown', (e) => {
        isDown = true;
        slider.classList.add('active');
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
        });
        slider.addEventListener('mouseleave', () => {
        isDown = false;
        slider.classList.remove('active');
        });
        slider.addEventListener('mouseup', () => {
        isDown = false;
        slider.classList.remove('active');
        });
        slider.addEventListener('mousemove', (e) => {
        if(!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 3; //scroll-fast
        slider.scrollLeft = scrollLeft - walk;
        });
        this.decanterregister = document.querySelector('.featured-society-register-form-container > form > button');
        this.decanterregisterinput = document.querySelector('.featured-society-register-form-container > form > input');
        if(this.decanterregister) {
            this.decanterregister.addEventListener('click', (event) => {
                if(this.decanterregisterinput.value !== '') {
                    dataLayer.push({
                        event: 'society_form_register'
                    });
                    event.preventDefault();
                    theme.quickMedalRegisterDrawer.opendrawer(this.decanterregisterinput.value);
                    theme.quickMedalRegisterDrawer.label.decanter_code.classList.add('focus');
                    return false;
                } else {
                    return true;
                }
            })    
        }
    }
    
}

customElements.define('recommended-products', RecommendedProducts);